"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.paintbrush = void 0;
var paintbrush = {
  "viewBox": "0 0 512 512",
  "children": [{
    "name": "g",
    "attribs": {},
    "children": [{
      "name": "path",
      "attribs": {
        "d": "M149.515,283.349c-51.921,0-83.939,45.661-83.939,95.085c0,22.691-10.071,39.153-33.575,48.104\r\n\t\tc17.907,34.678,87.777,41.157,117.515,35.797c35.642-6.426,80.077-24.873,90.654-76.969\r\n\t\tC252.48,324.739,201.434,283.349,149.515,283.349z"
      },
      "children": [{
        "name": "path",
        "attribs": {
          "d": "M149.515,283.349c-51.921,0-83.939,45.661-83.939,95.085c0,22.691-10.071,39.153-33.575,48.104\r\n\t\tc17.907,34.678,87.777,41.157,117.515,35.797c35.642-6.426,80.077-24.873,90.654-76.969\r\n\t\tC252.48,324.739,201.434,283.349,149.515,283.349z"
        },
        "children": []
      }]
    }, {
      "name": "path",
      "attribs": {
        "d": "M467.638,60.356c-12.955-12.948-29.964-17.292-44.92-5.35L247.598,209.1c-8.648-2.371-16.525-1.869-22.909,2.346\r\n\t\tL165.896,260.4c-1.611,1.611-1.545,4.304,0.066,5.914c0.499,0.501,1.064,0.79,1.697,0.98c0.642,0.034,1.264,0.059,1.899,0.103\r\n\t\tc0.019-0.002,0.036-0.01,0.054-0.014c47.938,3.432,91.034,36.754,89.3,89.506c-0.016,0.505-0.029,1.007-0.054,1.516\r\n\t\tc0.123,0.848,0.5,1.664,1.149,2.315c1.595,1.593,4.168,1.605,5.781,0.044c0.018-0.018,0.037-0.027,0.055-0.044\r\n\t\tc0.063-0.063,0.106-0.137,0.164-0.2l50.457-57.342c4.216-6.374,4.72-14.24,2.355-22.875l154.169-175.047\r\n\t\tC484.939,90.308,480.592,73.308,467.638,60.356z"
      },
      "children": [{
        "name": "path",
        "attribs": {
          "d": "M467.638,60.356c-12.955-12.948-29.964-17.292-44.92-5.35L247.598,209.1c-8.648-2.371-16.525-1.869-22.909,2.346\r\n\t\tL165.896,260.4c-1.611,1.611-1.545,4.304,0.066,5.914c0.499,0.501,1.064,0.79,1.697,0.98c0.642,0.034,1.264,0.059,1.899,0.103\r\n\t\tc0.019-0.002,0.036-0.01,0.054-0.014c47.938,3.432,91.034,36.754,89.3,89.506c-0.016,0.505-0.029,1.007-0.054,1.516\r\n\t\tc0.123,0.848,0.5,1.664,1.149,2.315c1.595,1.593,4.168,1.605,5.781,0.044c0.018-0.018,0.037-0.027,0.055-0.044\r\n\t\tc0.063-0.063,0.106-0.137,0.164-0.2l50.457-57.342c4.216-6.374,4.72-14.24,2.355-22.875l154.169-175.047\r\n\t\tC484.939,90.308,480.592,73.308,467.638,60.356z"
        },
        "children": []
      }]
    }, {
      "name": "polygon",
      "attribs": {
        "points": "165.887,260.409 165.896,260.4 165.888,260.407 \t"
      },
      "children": [{
        "name": "polygon",
        "attribs": {
          "points": "165.887,260.409 165.896,260.4 165.888,260.407 \t"
        },
        "children": []
      }]
    }]
  }]
};
exports.paintbrush = paintbrush;